import { money } from "@/lib/api";

export const feeLabel = (c) => (c.fee_estimated ? "Estimated monthly HOA fee" : c.fee_frequency === "Monthly" ? "Monthly HOA fee" : "HOA fee");
export const yearlyFee = (c) => (c.fee_frequency === "Monthly" && c.monthly_fee != null ? Math.round(c.monthly_fee * 12) : null);

export const FeeBox = ({ c }) => {
  const yearly = yearlyFee(c);
  const big = c.fee_estimated ? money(c.monthly_fee) : c.fee_range || money(c.monthly_fee);
  return (
    <div className="rounded-xl bg-[#0B2150] text-white p-6 sm:p-7" data-testid="community-fee-box">
      <p className="text-xs sm:text-sm uppercase tracking-[0.12em] text-slate-300 font-medium">{feeLabel(c)}</p>
      <p className="mt-2 font-display text-5xl sm:text-6xl font-bold tracking-tight" data-testid="community-fee-value">{big}</p>
      {c.fee_estimated && c.fee_range && <p className="mt-1 text-sm text-slate-300">Typical range {c.fee_range}</p>}
      {yearly != null && (
        <div className="mt-5 pt-5 border-t border-white/20 flex items-center justify-between gap-4">
          <span className="text-sm sm:text-base text-slate-300">{c.fee_estimated ? "Est. Yearly Fee" : "Yearly Fee (avg.)"}</span>
          <span className="font-display text-lg sm:text-xl font-bold" data-testid="community-yearly-fee">{money(yearly)}/yr</span>
        </div>
      )}
      {c.fee_estimated && <p className="mt-4 text-xs text-slate-400">Estimate only. Not confirmed by the HOA.</p>}
    </div>
  );
};
